<template>
  <vue-form @submit="submit"
           :disabled="isFormDisabled"
           :form="form"
           :action="action"
           :status="status">
    <section class="form-section">
      <header>
        <h3>Boutique</h3>
        <p>
          La boutique permet de définir le point de retrait pour les commandes.
          Le code est utilisé sur les différents rapports pour identifié la boutique
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="name" label="Nom">
          <vue-input placeholder="ex: Boutique Limoges" id="name" v-model="form.name" :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section">
      <header>
        <h3>Code</h3>
        <p>
          Le code est utilisé sur les différents rapports pour identifié la boutique
        </p>
      </header>
      <div>
        <form-group class="md:w-1/2" field="code" label="Code">
          <vue-input placeholder="ex: LIM" id="name" v-model="form.code" :disabled="isFormDisabled"/>
        </form-group>
      </div>
    </section>
    <section class="form-section" v-if="isUpdateForm && canDelete">
      <header>
        <h3>Zone de danger</h3>
        <p>
          La boutique sera <strong>définitivement supprimée</strong> et ne pourra pas être restaurée.
        </p>
      </header>
      <div>
        <form-group label="Voulez-vous supprimer définitivement cette boutique ?">
          <confirm-button @confirmed="destroy"
                          popover-type="popover-top-left sm:popover-right"
                          btn-class="btn-primary btn-outline"
                          btn-confirm-text="Supprimer"
                          :disabled="isFormDisabled"
                          :status="statusDestroy">Supprimer la boutique</confirm-button>
        </form-group>
      </div>
    </section>
  </vue-form>
</template>

<script>
import Form from 'form-backend-validation';
import form from '../../mixins/form';

export default {
  mixins: [form],

  data() {
    return {
      form: new Form({
        name: '',
        code: '',
      }),
    };
  },
};
</script>